import app from '../app';

let sendTime = 0;
// 普通的发送验证码
const sendCodeToMobileOption1 = {
  url: '/api/sendVerifyCode',
  method: 'POST',
}
// E签宝的发送验证码
const sendCodeToMobileOption2 = {
  url: '/api/esign/sendSignMobileCode',
}

export function verifyMobileWithCode(mobile, code) {
  return new Promise(resolve => {
    if (!mobile) {
      throw new Error('请输入手机号');
    }
    if (!code) {
      throw new Error('请输入验证码');
    }

    resolve({ mobile, code });
  })
    .then(data =>
      app.fetchAPI({
        url: '/api/checkVerifyCode',
        method: 'POST',
        data,
      })
    )
    .then(
      () => ({}),
      error => {
        app.showTips('error', error.message);
        return { error };
      }
    );
}

export function sendCodeToMobile(mobile, verifyType, apiOptionType, captchaVerifyParam, channel) {
  let prevSendTime;
  return new Promise(resolve => {
    if (!mobile) {
      throw new Error('请输入手机号');
    }

    prevSendTime = sendTime;
    sendTime = new Date().getTime();

    const apiOption =  apiOptionType === 2 ? sendCodeToMobileOption2 : sendCodeToMobileOption1;
    const data = { mobile, verifyType };
    if (captchaVerifyParam) {
      data.captchaVerifyParam = captchaVerifyParam;
    }
    if (channel) {
      data.channel = channel;
    }
    resolve({ apiOption, data });
  })
    .then(({ apiOption, data }) =>
      app.fetchAPI({
        ...apiOption,
        data,
      })
    )
    .then(
      response => response || {},
      error => {
        sendTime = prevSendTime;
        app.showTips('error', error.message);
        return { error };
      }
    );
}

export function getLastSendTime() {
  return sendTime;
}
